import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import M from 'materialize-css';
import { getCountryData } from '../../utils/CountryUtil';

const SelectState = forwardRef(({ country, changeState }, ref) => {
  const [states, setStates] = useState([]);
  const [state, setState] = useState('');

  useEffect(() => {
    M.AutoInit();
  }, []);

  useEffect(() => {
    let elems = document.querySelector('#selectState');
    M.FormSelect.init(elems);
  }, [states]);

  useEffect(() => {
    if (country) {
      const countryAndProvince = getCountryData(country);
      setStates(countryAndProvince.regions);
      setState('');
    }
  }, [country]);

  const updateState = (newState) => {
    setState(newState);
    if (changeState) {
      changeState(newState);
    }
  };

  useImperativeHandle(ref, () => ({
    getState: state,
  }));

  const renderSelect = () => (
    <div className="input-field s12">
      <select id="selectState" value={state} onChange={(e) => updateState(e.target.value)}>
        <option value="" disabled>
          Select your State
        </option>
        {states.map((s, index) => (
          <option key={index} value={s.shortCode}>
            {s.name}
          </option>
        ))}
      </select>
    </div>
  );

  return <div>{country === null || state === null ? <div /> : renderSelect()}</div>;
});

export default SelectState;
